// extracted by mini-css-extract-plugin
export default {"wrapper":"TownsFieldset_wrapper__fPA-y","introText":"TownsFieldset_introText__CMVHQ"};